module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"moreBracket":"[mehr]","lessBracket":"[weniger]","imprint":"Impressum","tos":"AGB","privacy":"Datenschutz"},"en":{"moreBracket":"[more]","lessBracket":"[less]","imprint":"Imprint","tos":"Terms of Service","privacy":"Privacy Policy"}}')
  delete Component.options._Ctor
}
